import React, { useState } from 'react';
import { Accordion } from '@mantine/core';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';
import dt from '~/testing';

import useContestNotificationWidget from '../../hooks/useContestNotificationWidget';

import useStyles from './ContestNotificationWidget.styles';
import type { ContestNotificationWidgetProps } from './types';
import ContestNotificationWidgetHeader from './ContestNotificationWidgetHeader';
import ContestNotificationWidgetContent from './ContestNotificationWidgetContent';
import ContestNotificationWidgetFooter from './ContestNotificationWidgetFooter';

function ContestNotificationWidget({
  content,
  totalCount,
  onViewAllClick,
  isFullWidth,
  isForceOpen,
}: ContestNotificationWidgetProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const { cx, classes } = useStyles();
  const { title, count, displayItems, hasItems } = useContestNotificationWidget({
    content,
    totalCount,
  });

  if (!hasItems) {
    return null;
  }

  const handleChange = (value: string) => {
    setIsOpen(!!value);
  };

  return (
    <Accordion
      className={cx(classes.container, { isOpen })}
      defaultValue={(isMobile || isForceOpen) && 'widgetContent'}
      chevronPosition="left"
      data-test-id={dt.contest.common.contestNotificationWidget}
      onChange={handleChange}
    >
      <Accordion.Item value="widgetContent">
        <ContestNotificationWidgetHeader
          title={title}
          count={totalCount || count}
          onViewAllClick={onViewAllClick}
        />
        <Accordion.Panel>
          <ContestNotificationWidgetContent
            content={content}
            displayItems={displayItems}
            isFullWidth={isFullWidth}
          />
          {isMobile && !!onViewAllClick && (
            <ContestNotificationWidgetFooter onViewAllClick={onViewAllClick} />
          )}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}

export default ContestNotificationWidget;
